import { getRouteApi } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import Loading from '@/components/Loading'
import BasicLayout from '@/components/common/BasicLayout/BasicLayout'
import { toast } from '@/hooks/useToast'
import queryClient from '@/queryClient'

import SchoolBreakForm from '../components/SchoolBreakForm'
import useEditSchoolBreak from '../mutations/useEditSchoolBreak'
import { useSchoolBreak } from '../queries/useSchoolBreak'

const routeApi = getRouteApi('/_auth/school-settings/breaks/$breakId/edit')

const SchoolBreakEditView = () => {
  const navigate = routeApi.useNavigate()
  const { breakId } = routeApi.useParams()
  const { t } = useTranslation(['schoolSettings', 'common'])

  const { data: breakData } = useSchoolBreak(breakId)

  const {
    mutate: editSchoolBreak,
    isPending: isEditSchoolBreakPending,
    formErrors
  } = useEditSchoolBreak({
    onSuccess: () => {
      toast({
        variant: 'success',
        title: t('toast.school-break-edit-success')
      })
      queryClient.invalidateQueries({
        queryKey: ['panelSchoolBreaksRetrieve', breakId]
      })
      queryClient.invalidateQueries({
        queryKey: ['panelSchoolBreaksList']
      })
      navigate({
        to: '/school-settings/breaks/$breakId',
        params: {
          breakId
        }
      })
    },
    onError: () => {
      toast({
        variant: 'error',
        title: t('toast.school-break-edit-error')
      })
    }
  })

  const defaultValues = breakData
    ? {
        name: breakData.name,
        dates: {
          from: breakData.startDate,
          to: breakData.endDate
        }
      }
    : undefined

  return (
    <BasicLayout
      breadcrumbs={[
        {
          title: t('common:navigation.school-settings'),
          to: '/school-settings'
        },
        {
          title: t('header.edit-school-break')
        }
      ]}
      header={t('header.edit-school-break')}
      moduleName={t('common:header.administration')}
    >
      <Loading spinning={isEditSchoolBreakPending}>
        {defaultValues ? (
          <SchoolBreakForm
            defaultValues={defaultValues}
            errors={formErrors}
            onSubmit={payload =>
              editSchoolBreak({
                id: breakId,
                ...payload
              })
            }
          />
        ) : null}
      </Loading>
    </BasicLayout>
  )
}

export default SchoolBreakEditView
